import { useGSAP, useGSAPConfig } from '@gsap/react'
import gsap from 'gsap'

import { MediaQuery } from '@/constants'

export type TouchMediaContext = Partial<{
  // eslint-disable-next-line no-unused-vars
  touch: (context: gsap.Context) => void
  // eslint-disable-next-line no-unused-vars
  pointer: (context: gsap.Context) => void
  revert: () => void
}>

export const useMotionTouchMedia = (
  { touch, pointer, revert }: TouchMediaContext,
  dependencies?: unknown[] | useGSAPConfig
) => {
  useGSAP((context) => {
    const matchMedia = gsap.matchMedia().add(
      {
        isTouch: MediaQuery.TOUCH,
        isPointer: MediaQuery.POINTER
      },
      ({ conditions }) => {
        const { isTouch, isPointer } = conditions as gsap.Conditions
        isTouch ? touch?.(context) : isPointer ? pointer?.(context) : null

        return () => {
          revert?.()
        }
      }
    )

    return () => {
      matchMedia.revert()
    }
  }, dependencies)
}
